/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_addGroupCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($rootScope, $scope, $http, NetworkService, MainService, IntentService) {

        $scope.createGroup = function ()
        {
            $rootScope.$on("getGroupMembersReturnForDialog", function (event, data) {
                var persons = data.group;
                console.log("....")
                console.log(persons)
                var groupName = $scope.groupname
                var groupDescr = $scope.groupdescr
                NetworkService.addGroup(groupName, groupDescr, function (data) {
                    var id = data.position_id
                    persons.forEach(function (el) {
                        //console.log(el)
                        NetworkService.addPersonToGroup(el.Email, groupName)
                    })
                    $rootScope.$emit("repaint")
                })

            })

            $rootScope.$emit("getGroupMembersForDialog")

        }
    }])